module.exports = __webpack_public_path__ + "img/fire-flame-07.2c31a468.png";